export default "__VITE_ASSET__C80ytkf6__"